import type { Locale } from './config';

export function localeField<T extends Record<string, unknown>>(
  row: T,
  base: string,
  locale: Locale
): string {
  const key = `${base}_${locale}` as keyof T;
  const fallback = `${base}_es` as keyof T;
  const value = (row[key] as string) || (row[fallback] as string) || '';
  return value;
}

export function localePath(path: string, locale: Locale): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `/${locale}${clean === '/' ? '' : clean}`;
}
